// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3khm-","rootSuccess":"CompleteLink_rootSuccess__32gXc","rootFailure":"CompleteLink_rootFailure__3mfL6","isDisabled":"CompleteLink_isDisabled__3Gw67"};